<template>
  <section class="section4-container">
    <div class="section4-bg">
      <div class="content-container">
        <div class="title-wrapper">
          <p class="title">
            {{ $t("home.s4.t1") }}
          </p>
          <p class="title">
            {{ $t("home.s4.t2") }}
          </p>
        </div>
        <div class="mobile-title-wrapper">
          <p>{{ $t("home.s4.t1") }}</p>

          <p>
            {{ $t("home.s4.t3") }}
          </p>

          <p>{{ $t("home.s4.t4") }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.section4-container {
  margin-top: 40px;
  // margin-bottom: 40px;
  width: 100%;
  background: #3f4ae1;
  .section4-bg {
    width: 100%;
    height: 100%;
    background-image: url("../../../assets/home/bl.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
}
@media (max-width: 500px) {
  .mobile-title-wrapper {
    display: block;
    padding: 40px 0px;
    p {
      text-align: center;
      font-size: 16px;
      font-family: PingFangHK-Medium, PingFangHK;
      font-weight: 500;
      color: #ffffff;
      line-height: 22px;
    }
  }
  .title-wrapper {
    display: none;
  }
}

@media (min-width: 501px) {
  .mobile-title-wrapper {
    display: none;
  }
  .title-wrapper {
    // width: 740px;
    // height: 82px;
    display: block;
    margin: 0 auto;
    padding: 55px 0px;
    .title {
      text-align: center;
      font-size: 24px;
      font-family: PingFangHK-Medium, PingFangHK;
      font-weight: 500;
      color: #ffffff;
      line-height: 41px;
    }
  }
}
</style>
